export const IMPOTS_LESSONS_PT = [
  {
    id: 'impots-1',
    numero: 1,
    titre: "Compreender a declaração de rendimentos",
    sousTitre: "Porquê e quando?",
    contexte: "Todos os anos em Abril-Maio, os residentes em França declaram os seus rendimentos. Mas porquê exactamente, e o que acontece se não o fizerem?",
    explication: [
      "**A declaração de rendimentos** permite ao Estado calcular o imposto que deve pagar — ou o reembolso que pode receber.",
      "**Quem deve declarar?** Toda a pessoa maior de idade residente em França, mesmo sem rendimentos ou se estiver isento de impostos.",
      "**Quando declarar?** Todos os anos entre Abril e Junho. O prazo varia consoante o seu departamento — verifique em impots.gouv.fr.",
      "**Se não declarar**, arrisca uma penalização de 10% sobre o seu imposto, com majorações adicionais. Em caso de dúvida, declare sempre.",
      "**Boa notícia**: se já declarou no ano passado, as suas informações estão pré-preenchidas. Muitas vezes basta verificar e validar.",
    ],
    question: "Quem deve fazer uma declaração de rendimentos em França?",
    options: [
      { id: 'a', text: "Toda a pessoa maior de idade residente em França, mesmo sem rendimentos", correct: true },
      { id: 'b', text: "Apenas as pessoas que pagam impostos", correct: false },
      { id: 'c', text: "Apenas os trabalhadores com contrato permanente", correct: false },
    ],
    explication_reponse: "Todos devem declarar, mesmo sem rendimentos — isso permite ao Estado calcular os seus direitos a certos apoios. Não declarar pode acarretar penalizações, mesmo que não seja tributável.",
  },
  {
    id: 'impots-2',
    numero: 2,
    titre: "Criar o seu espaço pessoal em impots.gouv.fr",
    sousTitre: "A primeira ligação",
    contexte: "Tudo se passa online em impots.gouv.fr. O primeiro passo é criar ou recuperar o seu espaço pessoal.",
    explication: [
      "**O site oficial** é impots.gouv.fr — apenas este site. Desconfie de sites semelhantes com endereço diferente.",
      "**O número fiscal** (numéro fiscal) tem 13 dígitos, encontra-se no canto superior esquerdo do aviso de imposto. Se não o tiver, ligue para 0809 401 401.",
      "**Criar a conta**: em impots.gouv.fr → 'Criar o meu espaço' → introduza o número fiscal e data de nascimento.",
      "**O código de activação** é enviado por correio para casa em 5-7 dias. É um procedimento de segurança normal — aguarde.",
      "**Após a activação**: pode aceder às suas declarações, avisos e correspondência com as Finanças.",
    ],
    question: "Onde encontrar o número fiscal (numéro fiscal)?",
    options: [
      { id: 'a', text: "No canto superior esquerdo do aviso de imposto", correct: true },
      { id: 'b', text: "No cartão de cidadão", correct: false },
      { id: 'c', text: "No cartão de eleitor", correct: false },
    ],
    explication_reponse: "O número fiscal encontra-se no canto superior esquerdo do seu aviso de imposto. Se o perdeu, ligue para 0809 401 401 (gratuito) para o obter.",
  },
  {
    id: 'impots-3',
    numero: 3,
    titre: "Preencher a declaração",
    sousTitre: "Passo a passo",
    contexte: "Chegou a hora de preencher a declaração. Graças ao pré-preenchimento, é mais simples do que parece.",
    explication: [
      "**O pré-preenchimento**: o empregador envia os seus dados directamente às Finanças. A sua declaração já vem preenchida com os seus salários.",
      "**A casa 1AJ** (ou 1BJ para o cônjuge): é onde introduz os seus salários anuais. Verifique o montante com o último recibo de vencimento.",
      "**Verifique todas as informações**: morada, situação familiar, filhos a cargo. Qualquer erro pode alterar o valor do imposto.",
      "**A correcção é permitida**: se notar um erro no montante pré-preenchido, corrija directamente — não haverá qualquer penalização.",
      "**Validação final**: clique em 'Verificar' depois em 'Verificar e enviar'. Receberá um comprovativo de envio — guarde-o.",
    ],
    question: "Os seus salários estão pré-preenchidos na declaração mas estão errados. O que deve fazer?",
    options: [
      { id: 'a', text: "Corrigir o montante directamente — é permitido e necessário", correct: true },
      { id: 'b', text: "Aceitar o montante sem alterações para evitar problemas", correct: false },
      { id: 'c', text: "Não enviar a declaração e aguardar contacto das Finanças", correct: false },
    ],
    explication_reponse: "Deve sempre corrigir montantes errados. Uma declaração com valor errado pode significar pagar mais imposto do que deve — ou menos, o que levará a um pedido de reembolso posterior.",
  },
  {
    id: 'impots-4',
    numero: 4,
    titre: "Compreender o aviso de imposto",
    sousTitre: "Interpretar o seu documento",
    contexte: "Recebeu o aviso. O que significam todos estes números e vai pagar ou receber?",
    explication: [
      "**O rendimento fiscal de referência** (revenu fiscal de référence): total dos seus rendimentos após deduções. Usado para calcular o direito a muitos apoios sociais.",
      "**Se o montante for positivo**: deve imposto ao Estado — debitado directamente da sua conta.",
      "**Se o montante for negativo**: o Estado reembolsa-o — depositado na sua conta em Agosto.",
      "**Isenção de imposto**: se o seu rendimento for inferior a um determinado limiar, está isento — mas deve declarar na mesma.",
      "**O aviso fica guardado**: em impots.gouv.fr pode aceder a todos os seus avisos anteriores. Muito útil para pedidos de apoios sociais.",
    ],
    question: "O seu aviso de imposto mostra um montante negativo. O que significa?",
    options: [
      { id: 'a', text: "O Estado reembolsa-o — será depositado na sua conta", correct: true },
      { id: 'b', text: "Deve dinheiro ao Estado e tem de pagar", correct: false },
      { id: 'c', text: "Há um erro na declaração e deve contactar as Finanças", correct: false },
    ],
    explication_reponse: "Um montante negativo no aviso de imposto significa um reembolso a seu favor. É normalmente depositado em Agosto directamente na sua conta bancária registada.",
  },
];
